import React from 'react';

const  EditIcon = ({ size = 20,color = '#0623c1', ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.41091 13.0159L13.0159 4.41086C13.3409 4.08586 13.8684 4.08586 14.1934 4.41086L15.5901 5.80753C15.9151 6.13253 15.9151 6.66003 15.5901 6.98503L6.98425 15.5892C6.82841 15.7459 6.61675 15.8334 6.39591 15.8334H4.16675V13.6042C4.16675 13.3834 4.25425 13.1717 4.41091 13.0159Z" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.4583 5.96667L14.0333 8.54167" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

export default EditIcon;